module.exports = __webpack_public_path__ + "media/icons/trash-d3aee7a42c57155fc045536d0f7cc7f7.svg";